import styled from 'styled-components';

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const Gears = styled.div`
  background-color: ${({ theme }) => theme.palette.common.XLIGHT_GREEN};
  border-radius: 8px;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const GearTitle = styled.div`
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
`;

export const Gear = styled.div`
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
`;

export const StepContainer = styled.div`
  padding: 16px;
  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme.palette.common.LIGHT_GREEN};

  &:not(:last-child) {
    margin-bottom: 24px;
  }
`;

export const StepNumber = styled.p`
  margin: 0 0 8px;
  font-family: ${({ theme }) => theme.fonts.secondary};
  color: ${({ theme }) => theme.palette.common.PRIMARY};
  font-size: 28px;
  line-height: 32px;
  font-weight: 700;
`;

export const IngredientsList = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 24px;
  margin-top: 16px;
  padding-top: 24px;
  border-top: 1px solid ${({ theme }) => theme.palette.common.LIGHT_GREEN};

  & > div {
    overflow: hidden;
    display: flex;
    align-items: center;
  }
`;
